import { useEffect, useState } from "react";
import { Bot, Mic, CheckCircle2, CalendarCheck } from "lucide-react";

const SCRIPT = [
  { from: "cliente", text: "Oi! Vocês têm horário amanhã à tarde pra uma limpeza de pele?" },
  { from: "ia", text: "Oi, Camila! 😊 Tenho sim: amanhã às 14:00 ou 16:00. Qual fica melhor pra você?" },
  { from: "cliente", voice: true, text: "🎤 áudio · \"pode ser às 16, por favor\"" },
  { from: "ia", text: "Perfeito! Limpeza de pele confirmada para amanhã às 16:00 ✅ Te lembro 1h antes, combinado?" },
  { from: "sistema", text: "Agendamento criado na Agenda · Dono avisado no celular" },
];

export function ChatDemo() {
  const [shown, setShown] = useState(0);
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const wait = (ms) => new Promise((r) => setTimeout(r, ms));
      while (!cancelled) {
        setShown(0);
        await wait(600);
        for (let i = 0; i < SCRIPT.length; i++) {
          if (cancelled) return;
          if (SCRIPT[i].from === "ia") { setTyping(true); await wait(1300); setTyping(false); }
          setShown(i + 1);
          await wait(SCRIPT[i].from === "sistema" ? 3200 : 1500);
        }
        await wait(1500);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="glow-card relative w-full max-w-md overflow-hidden rounded-3xl border-cyan-400/20 bg-slate-950/80 p-4 backdrop-blur-xl" data-testid="landing-chat-demo">
      <div className="mb-3 flex items-center gap-3 border-b border-slate-800 pb-3">
        <div className="grid h-10 w-10 place-items-center rounded-full bg-cyan-400/20 text-cyan-300"><Bot className="h-5 w-5" /></div>
        <div><p className="text-sm font-semibold text-white">Clínica Bella · Assistente FlowIA</p><p className="text-xs text-emerald-400">online · responde em segundos</p></div>
      </div>
      <div className="flex min-h-[300px] flex-col justify-end gap-2.5">
        {SCRIPT.slice(0, shown).map((m, i) => (
          m.from === "sistema" ? (
            <div key={i} className="animate-flow-in mx-auto flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-[11px] text-emerald-300"><CalendarCheck className="h-3.5 w-3.5" /> {m.text}</div>
          ) : (
            <div key={i} className={`animate-flow-in flex ${m.from === "ia" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed ${m.from === "ia" ? "border border-cyan-400/30 bg-cyan-400/15 text-cyan-50" : "bg-slate-800/90 text-slate-100"}`}>
                {m.voice && <span className="mb-1 flex items-center gap-1 text-[11px] text-slate-400"><Mic className="h-3 w-3 text-cyan-400" /> transcrito pelo Whisper</span>}
                {m.from === "ia" && <span className="mb-1 flex items-center gap-1 text-[11px] font-medium text-cyan-400"><CheckCircle2 className="h-3 w-3" /> IA</span>}
                {m.text}
              </div>
            </div>
          )
        ))}
        {typing && <div className="flex justify-end"><div className="flex items-center gap-1 rounded-2xl border border-cyan-400/30 bg-cyan-400/15 px-3.5 py-2.5"><span className="h-1.5 w-1.5 animate-bounce rounded-full bg-cyan-300" /><span className="h-1.5 w-1.5 animate-bounce rounded-full bg-cyan-300 [animation-delay:150ms]" /><span className="h-1.5 w-1.5 animate-bounce rounded-full bg-cyan-300 [animation-delay:300ms]" /></div></div>}
      </div>
    </div>
  );
}
